import formatCurrentOptionGroup from './formatCurrentOptionGroup';
export default formatCurrentOptionGroup;
